<template>
  <v-layout
    v-if="activeTool"
    class="home-footer-info"
    id="current-tool"
    style="flex: none;"
  >
    <BuildingFillSVG
      v-if="activeTool === 'fc_building'"
      class="bottomToolsSVG"
    />
    <!--<MultiFillSVG v-if="activeTool === 'MULTI'" class="bottomToolsSVG"></MultiFillSVG>-->
    <PoleFillSVG v-if="activeTool === 'fc_pole'" class="bottomToolsSVG" />
    <ChambreFillSVG v-if="activeTool === 'fc_manhole'" class="bottomToolsSVG" />
    <InfraFillSVG v-if="activeTool === 'fc_pathway'" class="bottomToolsSVG" />
    <CableFillSVG v-if="activeTool === 'fc_cable'" class="bottomToolsSVG" />
    <CabinetFillSVG v-if="activeTool === 'fc_cabinet'" class="bottomToolsSVG" />
    <!--<AiFillSVG v-if="activeTool === 'AI'" class="bottomToolsSVG"></AiFillSVG>-->
    <ClosureFillSVG v-if="activeTool === 'fc_closure'" class="bottomToolsSVG" />
    <ClusterFillSVG
      v-if="activeTool === 'fc_fiber_terminal_box'"
      class="bottomToolsSVG"
    />
    <ClusterToolFillSVG
      v-if="activeTool === 'fc_cluster_tool'"
      class="bottomToolsSVG"
    />
    <TowerFillSVG v-if="activeTool === 'fc_site'" class="bottomToolsSVG" />
    <CellFillSVG v-if="activeTool === 'fc_cell'" class="bottomToolsSVG" />
    <TobyBoxFillSVG
      v-if="activeTool === 'fc_toby_box'"
      class="bottomToolsSVG"
    />
    <PNFillSVG
      v-if="activeTool === 'fc_fiber_distribution_point'"
      class="bottomToolsSVG"
    />
    <COFillSVG
      v-if="activeTool === 'fc_optical_line_termination'"
      class="bottomToolsSVG"
    />
    <TechLocalFillSVG
      v-if="activeTool === 'fc_technical_local'"
      class="bottomToolsSVG"
    />
    <PNAreaFillSVG v-if="activeTool === 'fc_fdp_zone'" class="bottomToolsSVG" />
    <COAreaFillSVG v-if="activeTool === 'fc_olt_zone'" class="bottomToolsSVG" />
    <OtherAreaFillSVG
      v-if="activeTool === 'fc_annotation_zone'"
      class="bottomToolsSVG"
    />
    <ClosureAreaFillSVG
      v-if="activeTool === 'fc_closure_zone'"
      class="bottomToolsSVG"
    />
    <AnnotationPointFillSVG
      v-if="activeTool === 'fc_annotation_point'"
      class="bottomToolsSVG"
    />

    <FieldCableFillSVG
      v-if="activeTool === 'fc_field_cable'"
      class="bottomToolsSVG"
    />
    <SlackFillSVG v-if="activeTool === 'fc_slack'" class="bottomToolsSVG" />
    <AssetReservationFillSVG
      v-if="activeTool === 'fc_asset_reservation'"
      class="bottomToolsSVG"
    />

    <BulkTPFillSVG v-if="activeTool === 'fc_bulk_tp'" class="bottomToolsSVG" />

    <PointFillSVG
      v-if="activeTool === 'Point'"
      id="bottomPoint"
      class="bottomToolsSVG"
    />
    <LineFillSVG
      v-if="activeTool === 'LineString'"
      id="bottomLine"
      class="bottomToolsSVG line"
    />
    <PolygonFillSVG
      v-if="activeTool === 'Polygon'"
      id="bottomPolygon"
      class="bottomToolsSVG polygon"
    />
    <BundleFillSVG v-if="activeTool === 'fc_microduct_bundle'" class="bottomToolsSVG" />
    <VirtualFillSVG v-if="activeTool === 'fc_virtual'" class="bottomToolsSVG" />
    <BlockageFillSVG v-if="activeTool === 'fc_blockage'" class="bottomToolsSVG" />

    <CopySVG v-if="activeTool === 'Copy'" class="bottomToolsSVG" />
    <PasteSVG v-if="activeTool === 'Paste'" class="bottomToolsSVG" />
    <DeleteSVG v-if="activeTool === 'Delete'" class="bottomToolsSVG" />

    <ExternalImportFillSVG v-if="activeTool === 'external_import'" class="bottomToolsSVG" />

    <span style="padding-left: 4px; text-transform: uppercase;">
      {{ $tc(getTranslationKey(activeTool), 1) }}
    </span>
  </v-layout>
</template>

<script>
import BuildingFillSVG from "@/assets/tools_svgs/uniFill.svg";
import MultiFillSVG from "@/assets/tools_svgs/multiFill.svg";
import PoleFillSVG from "@/assets/tools_svgs/poleFill.svg";
import CabinetFillSVG from "@/assets/tools_svgs/cabinetFill.svg";
import ChambreFillSVG from "@/assets/tools_svgs/chambreFill.svg";
import InfraFillSVG from "@/assets/tools_svgs/infraFill.svg";
import CableFillSVG from "@/assets/tools_svgs/cableFill.svg";
import AiFillSVG from "@/assets/tools_svgs/aiFill.svg";
import ClosureFillSVG from "@/assets/tools_svgs/closureFill.svg";
import ClusterFillSVG from "@/assets/tools_svgs/clusterFill.svg";
import ClusterToolFillSVG from "@/assets/tools_svgs/clusterToolFill.svg";
import TowerFillSVG from "@/assets/tools_svgs/towerFill.svg";
import CellFillSVG from "@/assets/tools_svgs/cellFill.svg";
import TobyBoxFillSVG from "@/assets/tools_svgs/tobyBoxFill.svg";
import COFillSVG from "@/assets/tools_svgs/coFill.svg";
import PNFillSVG from "@/assets/tools_svgs/pnFill.svg";
import TechLocalFillSVG from "@/assets/tools_svgs/techLocalFill.svg";
import PNAreaFillSVG from "@/assets/tools_svgs/pnAreaFill.svg";
import COAreaFillSVG from "@/assets/tools_svgs/coFill.svg";
import OtherAreaFillSVG from "@/assets/tools_svgs/otherAreaFill.svg";
import ClosureAreaFillSVG from "@/assets/tools_svgs/closureAreaFill.svg";
import AnnotationPointFillSVG from "@/assets/tools_svgs/annotationPointFill.svg";
import FieldCableFillSVG from "@/assets/tools_svgs/fieldCableFill.svg";
import SlackFillSVG from "@/assets/tools_svgs/slackFill.svg";
import AssetReservationFillSVG from "@/assets/tools_svgs/assetReservationFill.svg";
import BulkTPFillSVG from "@/assets/tools_svgs/bulk_tp_fill.svg";
import PointFillSVG from "@/assets/tools_svgs/pointFill.svg";
import LineFillSVG from "@/assets/tools_svgs/lineFill.svg";
import PolygonFillSVG from "@/assets/tools_svgs/polygonFill.svg";
import CircleFillSVG from "@/assets/tools_svgs/circleFill.svg";
import BundleFillSVG from "@/assets/tools_svgs/bundleFill.svg";
import ExternalImportFillSVG from "@/assets/tools_svgs/externalImportFill.svg";
import VirtualFillSVG from "@/assets/tools_svgs/virtualFill.svg";
import BlockageFillSVG from "@/assets/tools_svgs/blockageFill.svg";
import CopySVG from "@/assets/tools_svgs/copy.svg";
import PasteSVG from "@/assets/tools_svgs/paste.svg";
import DeleteSVG from "@/assets/tools_svgs/delete.svg";

export default {
  name: "HomeFooterActiveTool",

  components: {
    BuildingFillSVG,
    MultiFillSVG,
    PoleFillSVG,
    ChambreFillSVG,
    InfraFillSVG,
    CableFillSVG,
    AiFillSVG,
    ClosureFillSVG,
    ClusterFillSVG,
    TowerFillSVG,
    CellFillSVG,
    CabinetFillSVG,
    TobyBoxFillSVG,
    PNFillSVG,
    COFillSVG,
    TechLocalFillSVG,
    PNAreaFillSVG,
    COAreaFillSVG,
    OtherAreaFillSVG,
    ClosureAreaFillSVG,
    AnnotationPointFillSVG,
    PointFillSVG,
    LineFillSVG,
    PolygonFillSVG,
    CircleFillSVG,
    CopySVG,
    PasteSVG,
    DeleteSVG,
    FieldCableFillSVG,
    SlackFillSVG,
    AssetReservationFillSVG,
    ClusterToolFillSVG,
    BulkTPFillSVG,
    BundleFillSVG,
    ExternalImportFillSVG,
    VirtualFillSVG,
    BlockageFillSVG,
  },

  computed: {
    activeTool() {
      let tool = this.$store.getters.tools_selectedObjectLayer;
      if (tool) {
        return tool;
      }
      return "";
    }
  },

  methods: {
    getTranslationKey(layer) {
      if (layer.includes("fc_technical_local")) {
        return "TechnicalLocal";
      } else if (layer.includes("fc_cluster_tool")) {
        return "Micro Routing";
      } else {
        return this.$store.getters.getLayerTranslationKey(layer);
      }
    }
  }
};
</script>

<style scoped>
#current-tool {
  display: flex;
  text-align: center;
  vertical-align: middle;
}

.bottomToolsSVG {
  width: 13px;
  vertical-align: middle;
  display: flex;
}

/*
.bottomToolsSVG *:not(g){
  fill: var(--primary-highlight);
}*/

#bottomPoint {
  width: 17px;
  right: -4px;
  position: relative;
}

#bottomLine {
  width: 15px;
}

#bottomPolygon {
  width: 13px;
}

#bottomCircle {
  width: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/ActiveTool.vue